import { generate } from '@/api/blindFundus'
import { getGenerateResult } from '@/views/blindFundus/getGenerateResult'

export function addGenerate(params, that) {
  that.createLoading = true
  generate(params).then(res => {
    if (res && res.success) {
      getGenerateResult({ ...params, progress_id: res.data }, that)
    } else {
      that.createLoading = false
      that.$message.error(res.msg)
    }
  }).finally(res => {
    that.createLoading = false
  })
}
